import React from 'react';
import { KeyboardCodes } from '../Helpers';

const LinkButton = ({ className = '', label, onClick, onKeyDown }) => {
    const internalKeyDown = e => {
        if ([KeyboardCodes.ENTER, KeyboardCodes.SPACE].includes(e.keyCode)) {
            onKeyDown();
        }
    };

    return (
        <button
            className={`clx-step__button-link ${className}`}
            type="button"
            onClick={onClick}
            onKeyDown={e => internalKeyDown}
        >
            {label}
        </button>
    );
};

export default LinkButton;
